import { render, staticRenderFns } from "./RoleDetailInput.vue?vue&type=template&id=0ee12b11&scoped=true&"
import script from "./RoleDetailInput.vue?vue&type=script&lang=js&"
export * from "./RoleDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./RoleDetailInput.vue?vue&type=style&index=0&id=0ee12b11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee12b11",
  null
  
)

export default component.exports